module.exports = __webpack_public_path__ + "static/media/coin.d8be1af6.png";